import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
import { fetchBrandingConfig } from "../../slices/thunks";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import { useBrandingTitle } from '../../hooks';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

const ForgetPasswordPage = (props : any) => {
  const dispatch : any = useDispatch();

  const validation : any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: '',
      email: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().trim().required(st('forgot_password_username_required_error')),
      email: Yup.string().email(st('email_khong_dung_dinh_dang_error')).required(st('vui_long_nhap_email_error')),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    }
  });


    const selectLayoutState = (state : any) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);

  const selectBrandingState = (state: any) => state.BrandingConfiguration;
  const brandingData = createSelector(
    selectBrandingState,
    (state) => ({
      config: state.config,
      loading: state.loading,
    })
  );
  const { config: brandingConfig } = useSelector(brandingData);

  React.useEffect(() => {
    dispatch(fetchBrandingConfig());
  }, [dispatch]);

    useBrandingTitle(st('dat_lai_mat_khau_text'));
  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img 
                      src={brandingConfig?.logoUrl || logoLight} 
                      alt={st('logo_alt')} 
                      height="50" 
                    />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">
                  {brandingConfig?.companyName || st('he_thong_quan_ly_xo_so_text')}
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                                        <h5 className="text-primary">{st('quen_mat_khau_title')}</h5>
                    <p className="text-muted">{st('dat_lai_mat_khau_cua_ban_text')}</p>

                    <i className="ri-mail-send-line display-5 text-success mb-3"></i>

                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    {st('nhap_email_da_dang_ky_neu_message')}
                  </Alert>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">{st('forgot_password_username_label')}</Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder={st('forgot_password_username_placeholder')}
                          type="text"
                          autoComplete="username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username && validation.errors.username ? true : false
                          }
                        />
                        {validation.touched.username && validation.errors.username ? (
                          <FormFeedback type="invalid"><div>{validation.errors.username}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label">{st('email_label')}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder={st('nhap_email_placeholder')}
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit">{st('gui_lien_ket_dat_lai_button')}</button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">{st('doi_da_toi_nho_lai_mat_text')} <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> {st('nhan_vao_day_button')} </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
